/**
 * Merges server-provided reserved spot keys with the keys the reserve API rejected as taken.
 * The map derives "blocked" from this list; a failed booking keeps those keys in the set so the
 * spots stay non-interactive while the user retries elsewhere. Failed keys are trimmed because
 * `applySpotsOverlayForMap` matches by exact string while `findFriendSlotsForSpotNames` trims —
 * a padded key would otherwise redden the slot chip without blocking the grid.
 *
 * `failedKeys` also accepts the pre-0.0.69 shape (`string | null`): the package ships as TS
 * source, so Metro strips types without checking them and a host still on the old call
 * signature reaches this code at runtime. Without the guard, `null` would throw in `for...of`
 * (crashing the spot-booking screen on every render) and a single string would iterate as
 * characters, silently blocking the wrong spots.
 */
export function computeReservedKeysForMap(
  reservedKeys: readonly string[],
  failedKeys: string | readonly string[] | null | undefined
): string[] {
  const normalizedFailedKeys = typeof failedKeys === 'string' ? [failedKeys] : (failedKeys ?? []);
  const set = new Set(reservedKeys);
  for (const key of normalizedFailedKeys) {
    const trimmed = key.trim();
    if (trimmed !== '') set.add(trimmed);
  }
  return Array.from(set);
}
